module.exports = "./img/7926b5c750e0688ac3a002ad4aec581e.jpg";